import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'ghost' | 'destructive';
  size?: 'default' | 'sm' | 'icon';
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((
  { children, variant = 'default', size = 'default', className = '', ...props },
  ref
) => {
  const variantClasses: Record<NonNullable<ButtonProps['variant']>, string> = {
    default: '',
    outline: 'border border-current bg-transparent',
    ghost: 'bg-transparent',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
  };
  const sizeClasses: Record<NonNullable<ButtonProps['size']>, string> = {
    default: '',
    sm: 'text-sm px-3 py-1.5',
    icon: 'inline-flex h-8 w-8 items-center justify-center',
  };

  return (
    <button ref={ref} className={`${variantClasses[variant]} ${sizeClasses[size]} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';
